package com.bikompanion.domain

/**
 * A bike's condition score over its most recent votes.
 *
 * A recent window rather than an all-time average, so a bike that has since been repaired
 * recovers instead of being haunted by an old fault forever. The window is the last few monthly
 * buckets the backend keeps, which serves that goal better than a fixed count of votes would —
 * last-30-votes treats a bike rated thirty times a day the same as one rated three times a year.
 */
data class BikeRatingScore(
    val key: BikeKey,
    val positiveCount: Int,
    val totalCount: Int,
    /**
     * How often each fault has been reported, over the same window.
     *
     * Free now that the backend counts issues per bike, and the difference between "riders
     * dislike this bike" and "four people have reported the same broken brake".
     */
    val issueCounts: Map<BikeIssue, Int> = emptyMap(),
) {
    val percentPositive: Int
        get() = if (totalCount == 0) 0 else (positiveCount * 100) / totalCount
}
